// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"UploadFile_dropzone__2MQZ_","reject":"UploadFile_reject__3VGe8","accept":"UploadFile_accept__Thl-a","browse-button":"UploadFile_browse-button__1sWyt"};